import { theme } from '@noths/polaris-client-ribbons-base';
import { pxToRem } from '@noths/polaris-client-styles';
import { css } from 'styled-components';

const { spacing } = theme;

export const anchored = css`
  border-radius: 0;
  box-shadow: 0 ${pxToRem(2)} ${pxToRem(4)} 0 rgba(0, 0, 0, 0.2);
`;

export const wrapper = css`
  display: flex;
  margin: 0 0 28px 0;
  padding: ${spacing.sm}px;
  border-radius: ${pxToRem(10)};
`;

export const status = {
  alert: css`
    background-color: var(--tertiary-yellow-50);
  `,
  warning: css`
    background-color: var(--tertiary-red-base);
  `,
  success: css`
    background-color: var(--tertiary-green-50);
  `,
  default: css`
    background-color: var(--neutral-black-30);
  `,
};

/**
 * #1 - The width and height on the Icon components are currently set in px, so using px
 * instead of rem here until that has been refactored to use rem.
 * #2 - Although the Icon components set a width on the icon, min-width is needed to
 * prevent flexbox shrinking the icon when the text reaches the end of the component.
 */
export const icon = css`
  align-self: flex-start;
  min-width: 24px;
`;

export const iconButton = css`
  padding: 0;
  border: none;
  background: none;
  cursor: pointer;
`;

export const message = css`
  margin: 0 0 0 ${pxToRem(12)};
  align-self: center;
  text-align: left;
  flex-grow: 1;
`;
